import React from "react";
import { Label, Pie, PieChart } from "recharts";

import ChartCard from "@/components/dashboard/chart-card";
import { ChartConfig, ChartContainer, ChartLegend, ChartLegendContent, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { cn } from "@/lib/utils";

interface PieChartGraphProps {
    chartContainerClassname?: string;
    title: string;
    value?: number;
    subtitle?: string;
    chartConfig: ChartConfig;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    chartData: any[];
    datakey: string;
    valuekey: string;
    centerValue?: number | string;
    centerText?: string;
}

const PieChartGraph: React.FC<PieChartGraphProps> = ({
    chartContainerClassname,
    title,
    value,
    subtitle,
    chartConfig,
    chartData,
    datakey,
    valuekey,
    centerValue,
    centerText,
}) => {
    return (
        <ChartCard title={title} value={value} subtitle={subtitle}>
            <ChartContainer config={chartConfig} className={cn("mx-auto max-h-[200px] w-full", chartContainerClassname)}>
                <PieChart>
                    <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} />
                    <ChartLegend content={<ChartLegendContent />} />
                    <Pie data={chartData} dataKey={datakey} nameKey={valuekey} innerRadius={50} strokeWidth={5}>
                        <Label
                            content={({ viewBox }) => {
                                if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                                    return (
                                        <text x={viewBox.cx} y={viewBox.cy} textAnchor="middle" dominantBaseline="middle">
                                            <tspan x={viewBox.cx} y={viewBox.cy} className="fill-foreground text-3xl font-bold">
                                                {centerValue}
                                            </tspan>
                                            <tspan x={viewBox.cx} y={(viewBox.cy || 0) + 24} className="fill-muted-foreground">
                                                {centerText}
                                            </tspan>
                                        </text>
                                    );
                                }
                            }}
                        />
                    </Pie>
                </PieChart>
            </ChartContainer>
        </ChartCard>
    );
};

export default PieChartGraph;
